var exports = {
  "tab": "x234b8571--8020b6--tab",
  "focus-visible": "x234b8571--8020b6--focus-visible",
  "text": "x234b8571--8020b6--text",
  "active": "x234b8571--8020b6--active",
  "count": "x234b8571--8020b6--count",
};

module.exports = exports;
